<template>

    <div></div>

</template>

<script>

import Vuex from 'vuex'

import {configuration} from '../../configuration'

import I18n from '@/modules/i18n'

export default {

    name: 'smartbanner',

    computed: {

        ...Vuex.mapGetters(['user', 'lang']),

        isConnected() {
            return !!Object.keys(this.user).length
        }

    },

    watch: {

        user (newValue, oldValue) {
            if (Object.keys(newValue).length !== Object.keys(oldValue).length) {
                if(Object.keys(newValue).length) {
                    this.removeSmartBanner()
                } else if(I18n.is.english(this)) {
                    this.activeSmartBanner()
                }
            }
        },

        lang () {
            if (I18n.is.english(this) && !Object.keys(this.user).length) {
                this.activeSmartBanner()
            } else {
                this.removeSmartBanner()
            }
        }
    },

    data: () => {

        return {
            alreadyStarted: false
        }
    },

    created() {
        this.installSmartBanner()
    },

    mounted() {
        if(!this.isConnected && I18n.is.english(this)) {
            this.activeSmartBanner()
        }
    },

    methods: {

        installSmartBanner() {
            window.Adjust.initSdk({
                appToken: configuration.tracking.adjustAppToken,
                environment: configuration.environment
            })
        },

        activeSmartBanner() {

            if(this.alreadyStarted) {
                window.Adjust.restart()

            } else {
                this.alreadyStarted = true
                window.Adjust.initSmartBanner({
                    webToken: configuration.tracking.smartBannerWebToken
                })
            }
        },

        removeSmartBanner() {
            window.Adjust.stop()
        }
    }
}

</script>
